import React, { useState, useEffect } from "react";
import { Container, Form, Button, Row, Col, Alert, Spinner } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../styles/AdSubmission.css";
import { shortenFileName } from "../utils/shortenFileName";
 
const AdSubmission = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
 const [errors, setErrors] = useState({
  start_date: "",
  end_date: ""
});
  const [formData, setFormData] = useState({
    institution_name: "",
    website: "",
    institution_address: "",
    contact_person_name: "",
    designation: "",
    start_date: "",
    end_date: "",
    contact_number: "",
    contact_mail_id: "",
    head_of_institution: "",
    qualification: "",
    registration_type: "",
    institution_licensing_authority: "",
    advertisement_package: "",
    copy_of_license: null,
    advertisement_image: null,
  });
 
  const [dropdownData, setDropdownData] = useState({
    registrationTypes: [],
    authorities: [],
    advertisementPackages: []
  });
 
  // Fetch dropdown data on component mount
  useEffect(() => {
    fetchDropdownData();
  }, []);
 
  const fetchDropdownData = async () => {
    try {
      // Get auth token for protected endpoints
      const token = localStorage.getItem('token');
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
 
      // Fetch registration types
      const regTypesResponse = await axios.get(`${process.env.REACT_APP_BASEURL}/registration-types`);
      if (regTypesResponse.data.success) {
        setDropdownData(prev => ({
          ...prev,
          registrationTypes: regTypesResponse.data.data
        }));
      }
 
      // Fetch licensing authorities
      const authoritiesResponse = await axios.get(`${process.env.REACT_APP_BASEURL}/licensing-authorities`);
      if (authoritiesResponse.data.success) {
        setDropdownData(prev => ({
          ...prev,
          authorities: authoritiesResponse.data.data
        }));
      }
 
      // Fetch advertisement pricing tiers (requires JWT)
      const packagesResponse = await axios.get(
        `${process.env.REACT_APP_BASEURL}/getallPricingTierswithoutauth`,
       
      );
      if (packagesResponse.data.success) {
        setDropdownData(prev => ({
          ...prev,
          advertisementPackages: packagesResponse.data.data
        }));
      }
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
      setError("Failed to load form options. Please refresh the page.");
    }
  };
 
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
 
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files && files[0]) {
      setFormData((prevData) => ({ ...prevData, [name]: files[0] }));
      console.log(`File selected for ${name}:`, files[0].name, files[0].size);
    } else {
      setFormData((prevData) => ({ ...prevData, [name]: null }));
    }
  };
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");
 
    // Validate required files
    if (!formData.copy_of_license) {
      setError("Please upload a copy of license.");
      setLoading(false);
      return;
    }
    if (!formData.advertisement_image) {
      setError("Please upload an advertisement image.");
      setLoading(false);
      return;
    }
 
    try {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/create-adsubmission`;
 
      const fd = new FormData();
      fd.append("institution_name", formData.institution_name);
      fd.append("website", formData.website);
      fd.append("institution_address", formData.institution_address);
      fd.append("contact_person_name", formData.contact_person_name);
      fd.append("designation", formData.designation);
      fd.append("contact_number", formData.contact_number);
      fd.append("start_date", formData.start_date);
      fd.append("end_date", formData.end_date);
      fd.append("contact_mail_id", formData.contact_mail_id);
      fd.append("head_of_institution", formData.head_of_institution);
      fd.append("qualification", formData.qualification);
      fd.append("registration_type", formData.registration_type);
      fd.append("institution_licensing_authority", formData.institution_licensing_authority);
      fd.append("advertisement_package", formData.advertisement_package);
      fd.append("status", "0"); // Set initial status as pending
      fd.append("is_approved", "false");
      fd.append("verification", "not paid");
 
      // Always append files (they are required)
      fd.append("copy_of_license", formData.copy_of_license);
      fd.append("advertisement_image", formData.advertisement_image);
 
      console.log("FormData contents:");
      for (let [key, value] of fd.entries()) {
        console.log(key, value);
      }
 
      const res = await axios.post(apiUrl, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
 
      if (res.data.success) {
        console.log("Ad submission created:", res.data.data);
        setSuccess("Ad submission created successfully! Redirecting to payment...");
       
        // Redirect to payment page with submission data
        setTimeout(() => {
          navigate('/ad-submission-payment', {
            state: {
              submissionData: res.data.data
            }
          });
        }, 2000);
      }
    } catch (error) {
      console.error("Error creating ad submission:", error);
      setError(error.response?.data?.message || "Something went wrong! Please try again.");
    } finally {
      setLoading(false);
    }
  };
 
  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}>
        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
          </div>
        </div>
      </section>
 
      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container ad-submission-content-container">
          <section className="ad-submission-section">
            <Container className="container-ad-submission">
              <h2 className="text-center ad-submission-heading mb-4">Advertisement Submission Form</h2>
              <p className="text-center ad-submission-subtitle mb-5">
                Submit your advertisement to reach our professional community
              </p>
 
              {error && (
                <Alert variant="danger" className="ad-submission-alert">
                  {error}
                </Alert>
              )}
 
              {success && (
                <Alert variant="success" className="ad-submission-alert">
                  {success}
                </Alert>
              )}
 
              <Form onSubmit={handleSubmit}>
                {/* Institution Information */}
                <div className="ad-submission-form-section">
                  <h4 className="ad-submission-section-title">Institution Information</h4>
                 
                  <Row className="mb-4">
                    <Col md={6}>
                      <Form.Group controlId="formInstitutionName">
                        <Form.Label className="form-label-ad-submission">Institution Name *</Form.Label>
                        <Form.Control
                          className="form-control-ad-submission"
                          type="text"
                          name="institution_name"
                          value={formData.institution_name}
                          onChange={handleInputChange}
                          placeholder="Enter institution name"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="formWebsite">
                        <Form.Label className="form-label-ad-submission">Website</Form.Label>
                        <Form.Control
                          className="form-control-ad-submission"
                          type="url"
                          name="website"
                          value={formData.website}
                          onChange={handleInputChange}
                          placeholder="https://www.example.com"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
 
                  <Row className="mb-4">
                    <Col md={12}>
                      <Form.Group controlId="formInstitutionAddress">
                        <Form.Label className="form-label-ad-submission">Institution Address *</Form.Label>
                        <Form.Control
                          className="form-control-ad-submission"
                          as="textarea"
                          rows={3}
                          name="institution_address"
                          value={formData.institution_address}
                          onChange={handleInputChange}
                          placeholder="Enter complete institution address"
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
 
                {/* Contact Information */}
                <div className="ad-submission-form-section">
                  <h4 className="ad-submission-section-title">Contact Information</h4>
                 
                  <Row className="mb-4">
                    <Col md={6}>
                      <Form.Group controlId="formContactPersonName">
                        <Form.Label className="form-label-ad-submission">Contact Person Name *</Form.Label>
                        <Form.Control
                          className="form-control-ad-submission"
                          type="text"
                          name="contact_person_name"
                          value={formData.contact_person_name}
                          onChange={handleInputChange}
                          placeholder="Enter contact person name"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="formDesignation">
                        <Form.Label className="form-label-ad-submission">Designation</Form.Label>
                        <Form.Control
                          className="form-control-ad-submission"
                          type="text"
                          name="designation"
                          value={formData.designation}
                          onChange={handleInputChange}
                          placeholder="Enter designation"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
 
                  <Row className="mb-4">
                    <Col md={6}>
                      <Form.Group controlId="formContactNumber">
                        <Form.Label className="form-label-ad-submission">Contact Number *</Form.Label>
                        <Form.Control
                          className="form-control-ad-submission"
                          type="tel"
                          name="contact_number"
                          value={formData.contact_number}
                          onChange={handleInputChange}
                          placeholder="Enter contact number"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="formContactMailId">
                        <Form.Label className="form-label-ad-submission">Contact Email *</Form.Label>
                        <Form.Control
                          className="form-control-ad-submission"
                          type="email"
                          name="contact_mail_id"
                          value={formData.contact_mail_id}
                          onChange={handleInputChange}
                          placeholder="Enter contact email"
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
 
                  <Row className="mb-4">
                    <Col md={6}>
                      <Form.Group controlId="formHeadOfInstitution">
                        <Form.Label className="form-label-ad-submission">Head of Institution</Form.Label>
                        <Form.Control
                          className="form-control-ad-submission"
                          type="text"
                          name="head_of_institution"
                          value={formData.head_of_institution}
                          onChange={handleInputChange}
                          placeholder="Enter head of institution name"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="formQualification">
                        <Form.Label className="form-label-ad-submission">Qualification</Form.Label>
                        <Form.Control
                          className="form-control-ad-submission"
                          type="text"
                          name="qualification"
                          value={formData.qualification}
                          onChange={handleInputChange}
                          placeholder="Enter qualification"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
 
                {/* Registration and Package Information */}
                <div className="ad-submission-form-section">
                  <h4 className="ad-submission-section-title">Registration & Package Information</h4>
                 
                  <Row className="mb-4">
                    <Col md={6}>
                      <Form.Group controlId="formRegistrationType">
                        <Form.Label className="form-label-ad-submission">Registration Type *</Form.Label>
                        <Form.Select
                          className="form-control-ad-submission"
                          name="registration_type"
                          value={formData.registration_type}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select registration type</option>
                          {dropdownData.registrationTypes.map((type) => (
                            <option key={type._id} value={type._id}>
                              {type.name}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="formInstitutionLicensingAuthority">
                        <Form.Label className="form-label-ad-submission">Institution Licensing Authority *</Form.Label>
                        <Form.Select
                          className="form-control-ad-submission"
                          name="institution_licensing_authority"
                          value={formData.institution_licensing_authority}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select licensing authority</option>
                          {dropdownData.authorities.map((authority) => (
                            <option key={authority._id} value={authority._id}>
                              {authority.name}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
 
                  <Row className="mb-4">
                    <Col md={12}>
                      <Form.Group controlId="formAdvertisementPackage">
                        <Form.Label className="form-label-ad-submission">Advertisement Package *</Form.Label>
                        <Form.Select
                          className="form-control-ad-submission"
                          name="advertisement_package"
                          value={formData.advertisement_package}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select advertisement package</option>
                            {dropdownData.advertisementPackages.map((pkg) => (
                              <option key={pkg._id} value={pkg._id}>
                                {pkg.name} - ₹{pkg.base_price} ({pkg.duration_years} year{pkg.duration_years > 1 ? 's' : ''})
                              </option>
                            ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  <Col md={6}>
  <Form.Group controlId="formStartDate">
    <Form.Label className="form-label-ad-submission">Start Date *</Form.Label>
    <Form.Control
      className="form-control-ad-submission"
      type="date"
      name="start_date"
      value={formData.start_date}
      onChange={(e) => {
        const value = e.target.value;
        handleInputChange(e);
        
        // Validate start date
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const selectedDate = new Date(value);
        
        if (selectedDate < today) {
          // Set error if date is in the past
          setErrors((prev) => ({
            ...prev,
            start_date: "Start date cannot be in the past"
          }));
        } else {
          // Clear error
          setErrors((prev) => ({
            ...prev,
            start_date: ""
          }));
        }
        
        // Re-validate end date if it exists
        if (formData.end_date) {
          const endDate = new Date(formData.end_date);
          if (endDate <= selectedDate) {
            setErrors((prev) => ({
              ...prev,
              end_date: "End date must be after start date"
            }));
          } else {
            setErrors((prev) => ({
              ...prev,
              end_date: ""
            }));
          }
        }
      }}
      min={new Date().toISOString().split("T")[0]}
      isInvalid={!!errors.start_date}
    />
    <Form.Control.Feedback type="invalid">
      {errors.start_date}
    </Form.Control.Feedback>
  </Form.Group>
</Col>

<Col md={6}>
  <Form.Group controlId="formEndDate">
    <Form.Label className="form-label-ad-submission">End Date *</Form.Label>
    <Form.Control
      className="form-control-ad-submission"
      type="date"
      name="end_date"
      value={formData.end_date}
      onChange={(e) => {
        const value = e.target.value;
        handleInputChange(e);
        
        // Validate end date
        if (formData.start_date) {
          const startDate = new Date(formData.start_date);
          const selectedEndDate = new Date(value);
          
          if (selectedEndDate <= startDate) {
            setErrors((prev) => ({
              ...prev,
              end_date: "End date must be after start date"
            }));
          } else {
            setErrors((prev) => ({
              ...prev,
              end_date: ""
            }));
          }
        }
      }}
      min={
        formData.start_date
          ? new Date(new Date(formData.start_date).getTime() + 86400000)
              .toISOString()
              .split("T")[0]
          : new Date().toISOString().split("T")[0]
      }
      disabled={!formData.start_date}
      isInvalid={!!errors.end_date}
    />
    <Form.Control.Feedback type="invalid">
      {errors.end_date}
    </Form.Control.Feedback>
  </Form.Group>
</Col>
                  </Row>
                </div>
 
                {/* File Uploads */}
                <div className="ad-submission-form-section">
                  <h4 className="ad-submission-section-title">Required Documents</h4>
                 
                  <Row className="mb-4">
                    <Col md={6}>
                      <Form.Group controlId="formCopyOfLicense" className="d-flex flex-column align-items-center align-items-md-start">
                        <Form.Label className="form-label-ad-submission">
                          Copy of License *
                        </Form.Label>
                        <div className="ad-submission-file-upload-container">
                          <Form.Control
                            className="file-input-ad-submission"
                            type="file"
                            name="copy_of_license"
                            onChange={handleFileChange}
                            accept=".pdf,.jpg,.jpeg,.png,.gif,.bmp,.webp"
                            required
                            id="copy_of_license_input"
                          />
                          <Button
                            variant="primary"
                            className="ad-submission-upload-btn w-auto"
                            onClick={() => document.getElementById('copy_of_license_input').click()}
                            type="button"
                          >
                            <i className="fas fa-upload me-2"></i>
                            {formData.copy_of_license ? 'Change License' : 'Upload License'}
                          </Button>
                        </div>
                        {formData.copy_of_license && (
                          <div className="ad-submission-file-selected">
                            <i className="fas fa-check-circle text-success me-2"></i>
                            <span className="text-success">
                              Selected: {shortenFileName(formData.copy_of_license.name)} ({(formData.copy_of_license.size / 1024 / 1024).toFixed(2)} MB)
                            </span>
                          </div>
                        )}
                        <Form.Text className="text-muted">
                          <i className="fas fa-info-circle me-1"></i>
                          Accepted formats: PDF, JPG, JPEG, PNG, GIF, BMP, WEBP (Max 10MB)
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="formAdvertisementImage" className="d-flex flex-column align-items-center align-items-md-start">
                        <Form.Label className="form-label-ad-submission">
                          Advertisement Image *
                        </Form.Label>
                        <div className="ad-submission-file-upload-container">
                          <Form.Control
                            className="file-input-ad-submission"
                            type="file"
                            name="advertisement_image"
                            onChange={handleFileChange}
                            accept=".jpg,.jpeg,.png"
                            required
                            id="advertisement_image_input"
                          />
                          <Button
                            variant="primary"
                            className="ad-submission-upload-btn w-auto"
                            onClick={() => document.getElementById('advertisement_image_input').click()}
                            type="button"
                          >
                            <i className="fas fa-upload me-2"></i>
                            {formData.advertisement_image ? 'Change Image' : 'Upload Image'}
                          </Button>
                        </div>
                        {formData.advertisement_image && (
                          <div className="ad-submission-file-selected">
                            <i className="fas fa-check-circle text-success me-2"></i>
                            <span className="text-success">
                              Selected: {shortenFileName(formData.advertisement_image.name)} ({(formData.advertisement_image.size / 1024 / 1024).toFixed(2)} MB)
                            </span>
                          </div>
                        )}
                        <Form.Text className="text-muted">
                          <i className="fas fa-info-circle me-1"></i>
                          Accepted formats: JPG, JPEG, PNG (Max 10MB)
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
 
                  {/* Submit Button - Moved closer to Required Documents */}
                  <Row className="d-flex justify-content-center mt-3">
                    <Button
                      variant="primary"
                      type="submit"
                      size="lg"
                      className="button-ad-submission w-auto"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
<Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        className="me-2"
        style={{
          width: "14px",
          height: "14px",
          borderWidth: "2px",
        }}
      />                          Submitting...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-credit-card me-2"></i>
                          Proceed to Payment
                        </>
                      )}
                    </Button>
                  </Row>
                </div>
              </Form>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};
 
export default AdSubmission;
 
 